import { Box, Flex, Heading, Text, Tooltip } from '@chakra-ui/react';
import { componentsApi } from '@texas/api/endpoints/chat/componentsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { useEffect } from 'react';
import { ComponentLoader } from '../ComponentLoader';
import { Icons } from '@texas/components/shared/Icons';

interface Props {
  componentId: number;
}

export function ArticleEntity({ componentId }: Props) {
  const { refetch, loading, data, error } = useApiResource(
    componentsApi.getSingleArticleEntityComponent,
  );

  useEffect(() => {
    refetch(componentId);
  }, [componentId, refetch]);

  return (
    <ComponentLoader loading={loading} error={error}>
      {data && (
        <Box
          borderLeft="2px solid white"
          _light={{ borderLeftColor: 'black' }}
          pl={3}
          role="group"
        >
          <AngularNavLink
            to="variant.options"
            navobj={{
              articleId: data.entityId,
              variantId: data.pdVariantId,
            }}
          >
            <Heading fontSize="md" pb={2}>
              {data.label}
            </Heading>
          </AngularNavLink>
          <Flex gap={2} alignItems="center">
            <AngularNavLink
              to="variant.options"
              navobj={{
                articleId: data.entityId,
                variantId: data.pdVariantId,
              }}
            >
              <Text>{data.entityName}</Text>{' '}
            </AngularNavLink>
            <ArticleLinks
              articleId={data.entityId}
              pdVariantId={data.pdVariantId}
            />
          </Flex>
        </Box>
      )}
    </ComponentLoader>
  );
}

function ArticleLinks({
  articleId,
  pdVariantId,
}: {
  articleId: number;
  pdVariantId: number | null;
}) {
  return (
    <Flex gap={1} _groupHover={{ opacity: 1 }} opacity={0}>
      <Tooltip label="Manage Article">
        <Box>
          <AngularNavLink
            to="article.management"
            navobj={{
              articleId: articleId,
            }}
          >
            <Icons.Cog />
          </AngularNavLink>
        </Box>
      </Tooltip>
      <Tooltip label="View Options">
        <Box>
          <AngularNavLink
            to="variant.options"
            navobj={{
              articleId: articleId,
              variantId: pdVariantId,
            }}
          >
            <Icons.PencilRuler />
          </AngularNavLink>
        </Box>
      </Tooltip>
      <Tooltip label="View Suppliers">
        <Box>
          <AngularNavLink
            to="variant.suppliers"
            navobj={{
              articleId: articleId,
              variantId: pdVariantId,
            }}
          >
            <Icons.Factory />
          </AngularNavLink>
        </Box>
      </Tooltip>
      <Tooltip label="View PD Versions">
        <Box>
          <AngularNavLink
            to="variant.versions"
            navobj={{
              articleId: articleId,
              variantId: pdVariantId,
            }}
          >
            <Icons.PaletteSwatch />
          </AngularNavLink>
        </Box>
      </Tooltip>
    </Flex>
  );
}
